import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { Outlet, Navigate } from "react-router-dom";
import { canAccessRegister } from "./AuthState";

function RegisterRoutes() {
  const { userInformation } = useContext(UserContext);

  return canAccessRegister(userInformation) ? (
    <Outlet />
  ) : (
    <Navigate to="/library" replace />
  );
}

export default RegisterRoutes;
